<script lang="ts">
  import * as Alert from '$lib/components/ui/alert';
  import { EditorJs } from 'query-strapi-v4';
  // type Block = $$Generic<EditorJs.Image | undefined>;
  type Block = $$Generic<EditorJs.Warning | undefined>;
  export let block = undefined as Block;

  const title = block.data.title;
  const message = block.data.message;
  // const file = block.data.file;
  // const defaultImage = file.formats?.medium ?? file.formats?.small ?? file.formats?.large ?? file;

  // Maybe only allow the lightbox for large images
  // const shouldExpandImage = Object.keys(file.formats).includes("large")

  // let isOpen: boolean = false;
</script>

<div class="my-7">
  <Alert.Root variant="destructive">
    <Alert.Title>{title ?? 'Attention!'}</Alert.Title>
    <Alert.Description>{@html message}</Alert.Description>
  </Alert.Root>
</div>
